import { render } from "./EficienciaDiaria.vue?vue&type=template&id=636b1666"
import script from "./EficienciaDiaria.vue?vue&type=script&lang=js"
export * from "./EficienciaDiaria.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__